import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'nominas/vacaciones-empleados-periodos';

/**
 * GET Vacaciones Empleados Periodos
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getVacacionesEmpleadosPeriodos = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Vacaciones Empleado Periodo
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getVacacionesEmpleadoPeriodo = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Vacaciones Empleado Periodo
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postVacacionesEmpleadoPeriodo = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Vacaciones Empleado Periodo
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchVacacionesEmpleadoPeriodo = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Vacaciones Empleado Periodo
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteVacacionesEmpleadoPeriodo = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
